import { ChallengesAPI } from '@/src/api';
import { useApiClient } from '@/src/hooks/api/useApiClient';
import { useTranslation } from 'react-i18next';

export const useChallengesApi = () => {
  const { t } = useTranslation();

  return new ChallengesAPI(useApiClient(), t);
};
